import CustomList from '../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../core/components/core/Util/List/CustomList/CustomListContainer';
import { loadData } from '../../../core/components/core/Util/List/CustomList/loadData';
import config from '../../config/config';
import { chooseProfileFilter } from '../../helpers/chooseProfileFilter';

function List() {
    const profileFilter = chooseProfileFilter();

    console.log(profileFilter)

    const pathFrontEnd = '/gci/units/';
    const endpointBackend = config.endpoints.backend;

    const paths = {
        pathAdd: pathFrontEnd + 'add',
        pathEdit: pathFrontEnd + 'edit',
        pathView: pathFrontEnd + 'view',
        endpointDelete: `${endpointBackend}gci/units/delete`,
        endpointGetAllProjects: `${endpointBackend}gci/projects/getall`,
        endpoint: `${endpointBackend}gci/units/getall`,
        endpointGetAllCompanies: `${endpointBackend}gci/companies/getall`
    }

    const filters = {
        validateOnChange: true,
        showGoBackButton: false,
        showSubmitButton: false,
        handleSubmit: loadData,
        fields: [
            !profileFilter.gci_company_id ? {
                name: 'gci_company_id',
                type: 'select',
                label: 'Empresa',
                options: [],
                optionsEndpoint: {
                    endpoint: paths.endpointGetAllCompanies,
                    label: 'name',
                    value: 'id'
                },
                validations: {
                    required: false
                },
                columnSize: 3
            } : {},
            {
                name: 'gci_project_id',
                type: 'select',
                label: 'Projeto',
                options: [],
                optionsEndpoint: {
                    endpoint: paths.endpointGetAllProjects,
                    label: 'project_name',
                    value: 'id',
                    params: {
                        filter: {
                            ...profileFilter
                        }
                    }
                },
                validations: {
                    required: false
                },
                columnSize: 3,
            },
            {
                name: 'status',
                type: 'select',
                label: 'Status da Unidade',
                options: [
                    {
                        label: 'Disponível',
                        value: 'available'
                    },
                    {
                        label: 'Reservada',
                        value: 'reserved'
                    },
                    {
                        label: 'Em Manutenção',
                        value: 'maintenance'
                    },
                    {
                        label: 'Indisponível',
                        value: 'unavailable'
                    },
                    {
                        label: 'Vendida',
                        value: 'sold'
                    }
                ],
                validations: {
                    required: false
                },
                columnSize: 3
            },
            {
                name: 'filtro',
                type: 'submit',
                label: 'Pesquisar',
                columnSize: 1
            },
            {
                name: 'reset',
                type: 'reset',
                label: 'Limpar',
                columnSize: 1
            },
        ]
    }

    let list = {
        labelTitle: 'Lista de Unidades',
        labelTitleButtonAdd: 'Incluir nova unidade',
        fieldsShowOnDelete: ['unit'],
        formFilters: filters,
        filter: {
            ...profileFilter
        },
        columns: [
            {
                name: 'project',
                label: 'Projeto',
            },
            {
                name: 'block',
                label: 'Bloco/Quadra',
                width: '120px'
            },
            {
                name: 'floor',
                label: 'Andar',
                width: '100px'
            },
            {
                name: 'number',
                label: 'Número',
                width: '100px'
            },
            {
                name: 'unit',
                label: 'Unidade',
                width: '150px'
            },
            {
                name: 'formattedStatus',
                label: 'Status',
                cell: (row) => {
                    const statusColors = {
                        sold: '#ff1e1eff',
                        available: '#38a169',
                        reserved: '#ddc120d6',
                        unavailable: '#4a5568',
                        maintenance: '#f39a1cff',
                    };
                    const color = statusColors[row.status] || '#a0aec0';
                    return (
                        <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <span style={{
                                display: 'inline-block',
                                width: '10px',
                                height: '10px',
                                borderRadius: '50%',
                                backgroundColor: color,
                                flexShrink: 0,
                            }} />
                            {row.formattedStatus}
                        </span>
                    );
                }
            }
        ]
    };

    list = { ...list, ...paths };

    return (
        <div>
            <CustomListContainer
                pathAdd={list.pathAdd}
                labelTitle={list.labelTitle}
                labelTitleButtonAdd={list.labelTitleButtonAdd}
                content={<CustomList list={{ ...list, ...paths }} />}
            />
        </div>
    );
}
export default List;
